import { SliceCaseReducers, ValidateSliceCaseReducers, createSlice } from '@reduxjs/toolkit';
import { Store } from '@sv-support-sdk/shared-types';

type TReleaseNotesState = Store.ReleaseNotes.IReleaseNotesState;

export const initialState = {
  releaseNotes: [],
  meta: {
    perPage: 10,
    total: 0,
    lastPage: 1,
    currentPage: 0,
  },
  loading: false,
} as Store.ReleaseNotes.IReleaseNotesState;

const createReleaseNotesSlice = <T extends TReleaseNotesState, Reducers extends SliceCaseReducers<T>>({
  name = 'releaseNotes',
  initialState,
  reducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
}) =>
  createSlice({
  name,
  initialState,
  reducers: {
    setReleaseNotes: (state, action) => ({
      ...state,
      releaseNotes: [...state.releaseNotes, ...action.payload.releaseNotes],
      meta: action.payload.meta,
    }),
    setLoading: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.loading = action.payload;
    },
    ...reducers
  },
});

export default createReleaseNotesSlice;
